import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Tên vật tư: ", -1)
const _hoisted_9 = { class: "col-lg-4 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { role: "alert" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 col-form-label fw-bold fs-6 text-end" }, " Mã vật tư: ", -1)
const _hoisted_15 = { class: "col-lg-4 fv-row" }
const _hoisted_16 = ["readonly", "disabled"]
const _hoisted_17 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { role: "alert" }
const _hoisted_20 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, [
  /*#__PURE__*/_createElementVNode("span", { role: "alert" }, "Mã vật tư đã bị trùng, vui lòng nhập mã khác")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6 text-start" }, " Đơn vị tính: ", -1)
const _hoisted_25 = { class: "col-lg-4 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { role: "alert" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6" }, " Mức dự trữ tối thiểu ", -1)
const _hoisted_31 = { class: "col-lg-4 fv-row" }
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { role: "alert" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label required fw-bold fs-6 text-end" }, " Mức dự trữ tối đa ", -1)
const _hoisted_36 = { class: "col-lg-4 fv-row" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { role: "alert" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, " Số dư đầu năm ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6 d-flex justify-content-end align-items-center" }, " Thu hồi? ", -1)
const _hoisted_42 = { class: "col-lg-1 fv-row d-flex align-items-center" }
const _hoisted_43 = ["checked"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 col-form-label fw-bold fs-6 d-flex justify-content-end align-items-center" }, " C/ty duyệt? ", -1)
const _hoisted_45 = { class: "col-lg-1 fv-row d-flex align-items-center" }
const _hoisted_46 = ["checked"]
const _hoisted_47 = { class: "mb-5" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, " Danh mục vật tư? ", -1)
const _hoisted_50 = { class: "col-lg-4 fv-row d-flex align-items-center" }
const _hoisted_51 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_CurrencyInputCustom = _resolveComponent("CurrencyInputCustom")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_TaiKhoanSelection = _resolveComponent("TaiKhoanSelection")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isEditingPage ? 'Cập nhật' : 'Tạo mới'), 1)
      ]),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        "color-type": _ctx.ButtonTypeColors.PRIMARY,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.push('/quan-ly/vat-tu/danh-sach')))
      }, null, 8, ["button-type", "color-type"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        class: "form",
        onKeypress: _cache[18] || (_cache[18] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                ref: "firstInput",
                type: "text",
                name: "name",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Tên vật tư",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
              }, null, 544), [
                [_vModelText, _ctx.name]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.nameErr), 1)
                ])
              ])
            ]),
            _hoisted_13,
            (_ctx.isEditingPage)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "code",
                      class: _normalizeClass([
										'form-control',
										'form-control-lg',
										'form-control-solid',
										_ctx.isEditingPage ? 'disable-input' : '',
									]),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSupplyCodeDuplicate = false)),
                      onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select())),
                      placeholder: "Mã vật tư",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.code) = $event)),
                      readonly: _ctx.isEditingPage,
                      disabled: _ctx.isEditingPage
                    }, null, 42, _hoisted_16), [
                      [_vModelText, _ctx.code]
                    ]),
                    (!_ctx.isSupplyCodeDuplicate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.codeErr), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isSupplyCodeDuplicate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "unitString",
                min: "0",
                class: "form-control form-control-lg form-control-solid",
                placeholder: "Đơn vị tính",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.unitString) = $event)),
                onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
              }, null, 544), [
                [_vModelText, _ctx.unitString]
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.unitStringErr), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_CurrencyInputCustom, {
                name: "minimumReserve",
                placeholder: "Mức dự trữ tối thiểu",
                "class-str": "form-control form-control-lg form-control-solid",
                currency: "EUR",
                modelValue: _ctx.minimumReserve,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.minimumReserve) = $event)),
                onFocus: _cache[9] || (_cache[9] = ($event: any) => ($event.target.select()))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.minimumReserveErr), 1)
                ])
              ])
            ]),
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_CurrencyInputCustom, {
                name: "maximumReserve",
                placeholder: "Mức dự trữ tối đa",
                "class-str": "form-control form-control-lg form-control-solid",
                currency: "EUR",
                modelValue: _ctx.maximumReserve,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.maximumReserve) = $event)),
                onFocus: _cache[11] || (_cache[11] = ($event: any) => ($event.target.select()))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.maximumReserveErr), 1)
                ])
              ])
            ])
          ]),
          _createVNode(_component_DivRow, { "additional-class": "mb-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_DivCol, { cols: 2 }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(_component_DivCol, { cols: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CurrencyInputCustom, {
                    placeholder: "Số dư đầu năm",
                    "class-str": "form-control form-control-lg form-control-solid",
                    modelValue: _ctx.soDuDauNam,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.soDuDauNam) = $event)),
                    onFocus: _cache[13] || (_cache[13] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "recall",
                  class: "form-check-input",
                  checked: _ctx.recall,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.recall) = $event))
                }, null, 8, _hoisted_43), [
                  [_vModelCheckbox, _ctx.recall]
                ])
              ]),
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "recall",
                  class: "form-check-input",
                  checked: _ctx.isApprovedByComp,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isApprovedByComp) = $event))
                }, null, 8, _hoisted_46), [
                  [_vModelCheckbox, _ctx.isApprovedByComp]
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_TaiKhoanSelection, {
              "label-cols": 2,
              "inputs-cols": 6,
              "ma-tai-khoan-prop": _ctx.thongTinTaiKhoan.ma_tai_khoan,
              "ma-chi-tiet-prop": _ctx.thongTinTaiKhoan.ma_chi_tiet,
              onOnSelect: _ctx.onSelectAccount
            }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_el_autocomplete, {
                modelValue: _ctx.tenDanhMucVatTu,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tenDanhMucVatTu) = $event)),
                ref: "danhMucVatTuInput",
                class: "w-100",
                clearable: "",
                placeholder: "Nhập mã để tìm kiếm",
                "value-key": "ten_danh_muc",
                "trigger-on-focus": false,
                "fetch-suggestions": _ctx.queryDanhMucVatTu,
                "highlight-first-item": true,
                onSelect: _ctx.onSelectDanhMucVatTu,
                onFocus: _cache[17] || (_cache[17] = ($event: any) => ($event.target.select()))
              }, {
                default: _withCtx(({ item }) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(item.ma_danh_muc) + " - ", 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.ten_danh_muc), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "fetch-suggestions", "onSelect"])
            ])
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_ButtonCustom, {
          "is-loading": _ctx.isLoading,
          "color-type": _ctx.ButtonTypeColors.PRIMARY,
          "button-type": _ctx.ButtonsType.SAVE,
          "delay-time": 0,
          onClick: _ctx.onSubmitButtonClicked
        }, null, 8, ["is-loading", "color-type", "button-type", "onClick"])
      ])
    ])
  ]))
}